export default __webpack_public_path__ + "static/media/icons8-database-administrator (1).6089c527.svg";